export default __webpack_public_path__ + "static/media/metamask-logo.3cfbe9f0.png";